module.exports = __webpack_public_path__ + "img/nav_4_disable.46183af4.png";